import axios, { AxiosRequestConfig } from 'axios'
import aspida from '@aspida/axios'

import api from '../../api/$api'
import {
  GetSpecialOfferReceiptResponse,
  SpecialOfferReceiptEntity,
  UpdateSpecialOfferReceiptDto,
} from '../../api/@types'
import {
  GetSpecialOfferReceiptQuery,
  ISpecialOfferReceipt,
} from '@/types/special-offer'

export const getSpecialOfferReceipts = async (
  query: GetSpecialOfferReceiptQuery | null,
): Promise<[ISpecialOfferReceipt[], number]> => {
  const config: AxiosRequestConfig = {
    params: {},
  }

  if (query) {
    config.params = {
      ...config.params,
      ...query,
    }
  }
  const instance = axios.create(config)

  try {
    const response = await instance.get<[ISpecialOfferReceipt[], number]>(
      'special-offer-receipts',
    )
    const [receipts, total] = response.data
    return [receipts, total]
  } catch {
    throw new Error('error.special-offer-receipts.getSpecialOfferReceipts')
  }
}

export const getSpecialOfferReceipt = async (
  id: number,
): Promise<GetSpecialOfferReceiptResponse> => {
  const client = api(aspida())

  try {
    const data = await client.special_offer_receipts._id(id).$get()
    return data
  } catch {
    throw new Error('error.special-offer-receipts.getSpecialOfferReceipt')
  }
}

export const updateSpecialOfferReceipt = async (
  id: number,
  body: UpdateSpecialOfferReceiptDto,
): Promise<SpecialOfferReceiptEntity> => {
  const instance = api(aspida())

  const data = await instance.special_offer_receipts._id(id).$put({ body })
  return data
}
